// Required fields in the contractor profile wizard get a red label, explained by
// <RequiredFieldsNote />. Keep the color in one place so every step matches.
export const REQUIRED_FIELD_COLOR = "#ff5c5c";

export const requiredLabelSx = { color: REQUIRED_FIELD_COLOR };
